<template>
    <div class="py-4 container-fluid">      
        <div class="card-body">
            <div class="row">
                <div class="col-lg-12">
                    <div class="row mb-5">
                        <div class="col-lg-3">
                            <edit-location-side-nav />
                        </div>
                        <div class="col-lg-9 mt-lg-0 mt-4">
                            <location-detail />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row"></div>
        </div>
    </div>        
</template>
<script>
import EditLocationSideNav from "./components/EditLocationSideNav.vue"
import LocationDetail from "./components/LocationDetail.vue"

export default {
    name: 'Location_edit_page',
    components: {
        EditLocationSideNav,
        LocationDetail
    },
    data() {
        return {
            Id: '',
            location: [],
            gets: []
        }
    },
    async mounted() {
        
    },
}
</script>